import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useState, useCallback } from "react";
import { ToastContainer } from "./ToastContainer";
const ToastContext = createContext(undefined);
export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error("useToast must be used within ToastProvider");
    }
    return context;
};
export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);
    const removeToast = useCallback((id) => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, []);
    const showToast = useCallback((message, type = "info", duration) => {
        const id = `toast-${Date.now()}-${Math.random()}`;
        const newToast = { id, message, type, duration };
        setToasts((prev) => [...prev, newToast]);
    }, []);
    const success = useCallback((message, duration) => {
        showToast(message, "success", duration);
    }, [showToast]);
    const error = useCallback((message, duration) => {
        showToast(message, "error", duration);
    }, [showToast]);
    const warning = useCallback((message, duration) => {
        showToast(message, "warning", duration);
    }, [showToast]);
    const info = useCallback((message, duration) => {
        showToast(message, "info", duration);
    }, [showToast]);
    const value = {
        toasts,
        showToast,
        success,
        error,
        warning,
        info,
        removeToast,
    };
    return (_jsxs(ToastContext.Provider, { value: value, children: [children, _jsx(ToastContainer, { toasts: toasts, onRemove: removeToast })] }));
};
